const actions = {
GET_AllAICREDENTIAL_DATA: "GET_AllAICREDENTIAL_DATA",
GET_AllAICREDENTIAL_DATA_SUCCESS: "GET_ALLAICREDENTIAL_DATA_SUCCESS",
GET_ALLAICREDENTIAL_DATA_FAILED: "GET_ALLAICREDENTIAL_DATA_FAILED",

  CREATE_USER_LOGIN: "CREATE_USER_LOGIN",
  CREATE_USER_LOGIN_SUCCESS: "CREATE_USER_LOGIN_SUCCESS",
  CREATE_USER_LOGIN_FAILED: "CREATE_USER_LOGIN_FAILED",
  CLEAR_USER_LOGIN_MESSAGES: "CLEAR_USER_LOGIN_MESSAGES", // ✅ ADD THIS

  UPDATE_AI_DETAILS: "UPDATE_AI_DETAILS",
  UPDATE_AI_DETAILS_SUCCESS: "UPDATE_AI_DETAILS_SUCCESS",
  UPDATE_AI_DETAILS_FAILED: "UPDATE_AI_DETAILS_FAILED",

  createUserLogin: (data) => ({
    type: actions.CREATE_USER_LOGIN,
    payload: { data },
  }),

  createUserLoginSuccess: (message) => ({
    type: actions.CREATE_USER_LOGIN_SUCCESS,
    payload: { message },
  }),

  createUserLoginFailed: (error) => ({
    type: actions.CREATE_USER_LOGIN_FAILED,
    payload: { error },
  }),

  clearUserLoginMessages: () => ({
    type: actions.CLEAR_USER_LOGIN_MESSAGES, // ✅ CLEAR
  }),
  getAllAICredentialData: () => ({
  type: actions.GET_AllAICREDENTIAL_DATA,
}),
getAllAICredentialDataSuccess: (data) => ({
  type: actions.GET_AllAICREDENTIAL_DATA_SUCCESS,
  payload: { data },
}),
getAllAICredentialDataFailed: (error) => ({
  type: actions.GET_ALLAICREDENTIAL_DATA_FAILED,
  payload: { error },
}),

  updateAiDetails: (id, data) => ({
    type: actions.UPDATE_AI_DETAILS,
    payload: { id, data },
  }),
  updateAiDetailsSuccess: (message) => ({
    type: actions.UPDATE_AI_DETAILS_SUCCESS,
    payload: { message },
  }),
  updateAiDetailsFailed: (error) => ({
    type: actions.UPDATE_AI_DETAILS_FAILED,
    payload: { error },
  }),

};

export default actions;
